import React, { useEffect } from 'react'
import { Alert, Container, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BannerMainImageSection from '../../bannerMainImageSection'
import withLocation from '../../withLocation'
import { connect, useDispatch } from 'react-redux'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { OnCancelProposalAcceptance } from '../../../actions/proposalsActions'
import Layout from '../../../layout'
import { VehicleDescriptionBlock } from 'components/styledComponents/vehicleDescriptionBlock'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
} from '../../../helpers'
import useNextSteps from 'helpers/usenextSteps'
import { PrimaryButton } from '@mmsg/louie'
import { Link } from 'react-router-dom'
import { IVehicleProps, NextStepValue } from 'utils/type'
import { MdErrorOutline } from 'react-icons/md'

interface IInputProps {
  isAuthenticated: boolean
  opportunityId: string
  consultantFirstName: string
  userFirstName: string
  estimate: { vehicle: IVehicleProps; vehicleDescription: string }
  nextSteps: { link: string; step: NextStepValue; isFetching: boolean }
}

interface IOnProposalAcceptanceProps {
  cancellationSubmittedForAcceptedProposal: boolean
  hasCancelSubmissionFailed: boolean
  errorMsgOnCancelAcceptedProposal: string
  isCancelRequestSubmitting: boolean
}

interface IStateProps {
  applicationRoles: { isConsultant: boolean }
  proposal: {
    proposal: {}
    OnProposalAcceptance: IOnProposalAcceptanceProps
  }
}
export const ProposalAccepted = ({
  isAuthenticated,
  opportunityId,
  consultantFirstName,
  userFirstName,
  estimate,
  nextSteps,
}: IInputProps) => {
  const isConsultant: boolean = useSelector(
    (state: IStateProps) =>
      state.applicationRoles && state.applicationRoles.isConsultant
  )
  const getNextSteps = useNextSteps()
  const { proposalCompleted, nextStepMethod } = getNextSteps
  const { link, step, isFetching } = nextSteps

  useEffect(() => {
    proposalCompleted && nextStepMethod()
  }, [proposalCompleted])

  useEffect(() => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:proposal:accepted' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:proposal:accepted' },
        },
      })
    }
  }, [isAuthenticated, opportunityId])

  let dispatch = useDispatch()
  let history = useHistory()

  let notificationElement = document.getElementById('notification')
  if (notificationElement) {
    notificationElement.style.display = 'none'
  }

  let proposalState: {} = useSelector(
    (state: IStateProps) => state.proposal.proposal
  )
  let OnProposalAcceptanceState: IOnProposalAcceptanceProps = useSelector(
    (state: IStateProps) => state.proposal.OnProposalAcceptance
  )
  if (
    OnProposalAcceptanceState &&
    OnProposalAcceptanceState.cancellationSubmittedForAcceptedProposal
  ) {
    history.push('/proposal/acceptance/cancelled')
  }
  return (
    <Layout>
      <div id="page" className="proceed-estimate-page">
        <BannerMainImageSection>
          <div>
            <h2 className="mb-0">OLY NOVATED LEASE</h2>
            <div className="mt-2 banner-content">
              Congratulations {userFirstName}!
            </div>
          </div>
        </BannerMainImageSection>
        {isFetching ? (
          <Container>
            <div className="mt-5 mb-5 d-flex justify-content-center">
              <img src="/images/loader.gif" alt="" />
            </div>
          </Container>
        ) : (
          <Container className="section mb-5">
            {step === NextStepValue.ATO && (
              <div className="mt-5 mb-3 text-center">
                <p>
                  You’ll receive a confirmation email shortly. To speed things
                  up {userFirstName}, proceed onto the next step, which is to
                  check and accept your Authority to Order.
                </p>
                <p>
                  <Link
                    to={{ pathname: link }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrimaryButton disabled={isConsultant}>
                      Authority to Order
                    </PrimaryButton>
                  </Link>
                </p>
              </div>
            )}
            {step === NextStepValue.DEFERRED && (
              <div className="mt-5 mb-3 text-center">
                <p>
                  If you have included add-on insurances in your lease, we will
                  send you a separate link to confirm the purchase of these
                  through our online portal or you can check back here.
                </p>
                <p>
                  Don't worry if you don't see this straight away as we are
                  required to send you this link at a later day after you have
                  time to consider if these insurances are right for you.
                </p>
                <p>
                  <Link
                    to={{ pathname: link }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrimaryButton disabled>
                      Confirm add-on insurances
                    </PrimaryButton>
                  </Link>
                </p>
              </div>
            )}
            {step === NextStepValue.INSURANCE && (
              <div className="mt-5 mb-3 text-center">
                <p>
                  You’ll receive a confirmation email shortly. {userFirstName},
                  please check the add-on insurances that you have included in
                  the lease and confirm you wish to proceed.
                </p>
                <p>
                  <Link
                    to={{ pathname: link }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrimaryButton disabled={isConsultant}>
                      Confirm add-on insurances
                    </PrimaryButton>
                  </Link>
                </p>
              </div>
            )}
            <div className="mt-4 mb-3 text-center">
              Before you know it, you’ll be driving your salary further in the{' '}
            </div>

            <VehicleDescriptionBlock {...estimate} />

            {step === NextStepValue.NONE && (
              <div className="mt-4 mb-5 text-center">
                We’ll take it from here {userFirstName}. You’ll recieve a
                confirmation email shortly, and {consultantFirstName} will be in
                touch soon to take care of the paperwork for you.
              </div>
            )}
            <div className="text-center">
              <ContactUsDialog
                className="mt-3 mb-24"
                theme="button"
                size="lg"
                launchText="Contact my consultant"
                invertColor={
                  step === NextStepValue.ATO ||
                  step === NextStepValue.INSURANCE ||
                  step === NextStepValue.DEFERRED
                }
              />
              <div className="font-weight-bold text-small">
                {!OnProposalAcceptanceState.cancellationSubmittedForAcceptedProposal && (
                  <>
                    {OnProposalAcceptanceState.isCancelRequestSubmitting ? (
                      <a href="#root" className="text-underline clickable">
                        <>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mb-1"
                          />
                          Submitting your cancellation request...
                        </>
                      </a>
                    ) : (
                      <a
                        href="#root"
                        style={{color:'#000', textDecoration:'underline',cursor:'pointer'}}
                        onClick={() => {
                          dispatch(
                            OnCancelProposalAcceptance(
                              opportunityId,
                              proposalState
                            )
                          )
                          fireInteractionCustomEvent({
                            detail: {
                              eventType: 'custom link click',
                              data: {
                                category: 'button',
                                section: 'mylease',
                                text: 'cancel proposal acceptance',
                                label: 'cancel proposal acceptance',
                              },
                            },
                          })
                        }}
                      >
                        Contact your consultant to cancel
                      </a>
                    )}

                    {OnProposalAcceptanceState.hasCancelSubmissionFailed &&
                      OnProposalAcceptanceState.errorMsgOnCancelAcceptedProposal !==
                        '' && (
                          <Alert variant={'danger'}>
                            <MdErrorOutline
                              color="#721c24"
                              size={`1.2em`}
                              style={{ minWidth: '20px' }}
                            />
                            {OnProposalAcceptanceState.errorMsgOnCancelAcceptedProposal}
                            </Alert>
                      )}
                  </>
                )}
              </div>
            </div>
          </Container>
        )}
      </div>
    </Layout>
  )
}

function mapStateToProps(
  state: {
    authentication: { isAuthenticated: boolean; opportunityId: string }
    individualEstimate: { estimate: {} }
    consultant: { firstName: string }
    user: { firstName: string }
    nextSteps: {}
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const estimate = state.individualEstimate.estimate || {}
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName } = state.user
  const nextSteps = state.nextSteps

  return {
    isAuthenticated,
    opportunityId,
    estimate,
    consultantFirstName,
    userFirstName,
    nextSteps,
  }
}
export default connect(mapStateToProps)(withLocation(ProposalAccepted))
